import { Injectable } from '@angular/core';
import { IRight } from 'src/app/shared/interface/right.interface';
import { RESTService } from './rest.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})

/** The RightService class provides methods for retrieving and setting selected rights using a REST
service. */
export class RightService {

  private _selectedRight: IRight;

  constructor(private _rest: RESTService) { }

  /** This function returns all scopes from the REST API */
  getAll() {
    return this._rest.get('scopes');
  }

  /** This function gets a scope by its title
   * @param {string} title - The title of the scope to be retrieved
   */
  getByTitle(title: string) {
    return this._rest.get('scopes/' + title);
  }

}
